import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styled, { css } from 'styled-components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { fontSizes, spacing } from 'syf-component-library/defaultTheme';
import { Button } from 'syf-component-library/ui/atoms';
import { Inset } from 'syf-component-library/ui/spacing';
import { Body, H5 } from 'syf-component-library/ui/typography';
import { DATA_ANALYTICS, DATA_REASON, DATA_TYPE } from '../../../const/analytics';
import { FAL_TIMES } from '../../../const/iconProps';
import { colors } from '../../../defaultTheme';
import { t } from '../../../strings/i18n';
const ExpandedDeletePrompt = styled(Inset) `
  border-top: 1px solid ${colors.mediumGrey};
  background-color: ${colors.lightGrey};
  display: flex;
  gap: ${spacing.base}px;
`;
const CloseIconWrapper = styled.div `
  position: absolute;
  top: -7px;
  right: 0;
`;
const CloseIcon = styled(FontAwesomeIcon) `
  cursor: pointer;
  color: ${colors.black};
  font-size: 1.5em;
`;
const Header = styled(H5) `
  font-size: ${fontSizes.root}px;
`;
const PromptIcon = styled(FontAwesomeIcon) `
  color: ${colors.deleteRedHover};
  font-size: 1.5em;
`;
const RemoveButton = styled(Button) `
  color: ${colors.deleteRedHover};
  text-transform: uppercase;
  margin-left: ${(props) => (props.isDesktop ? 'auto' : 0)};
  ${(props) => !props.isDesktop &&
    css `
      padding-left: 0;
    `}
`;
const DeletePromptWrapper = styled.div `
  display: flex;
  flex-direction: column;
  gap: 10px;
  position: relative;
  flex: 1;
`;
const PaymentMethodRemovePrompt = ({ paymentMethod, buttonRefs, leftIcon, isDesktop, onClose, handleConfirmDeletePaymentMethod }) => {
    const assignRef = (id, el) => {
        if (buttonRefs) {
            // eslint-disable-next-line no-param-reassign
            buttonRefs.current = Object.assign(Object.assign({}, buttonRefs.current), { [`remove-heading-${id}`]: el });
        }
    };
    return (_jsxs(ExpandedDeletePrompt, Object.assign({ bottom: "base", left: "large", right: "medium", top: "base" }, { children: [_jsx(PromptIcon, { "aria-hidden": true, icon: leftIcon, size: "lg" }), _jsxs(DeletePromptWrapper, { children: [_jsx(Header, Object.assign({ "data-cy": "remove-payment-method-prompt-heading", ref: (el) => assignRef(paymentMethod.id, el), tabIndex: 0, weight: "bold" }, { children: t('text.removePaymentMethod') })), _jsx(Inset, Object.assign({ bottom: "base", "data-cy": "remove-payment-method-prompt-message", right: "large", tabIndex: 0 }, { children: _jsx(Body, { children: t('text.removePaymentMethodPermanently') }) })), _jsxs("div", { children: [_jsx(RemoveButton, Object.assign({ buttonType: "text", "data-analytics": DATA_ANALYTICS.CLICK_TRACKING_EVENT, "data-reason": DATA_REASON.MANAGE_PAYMENT_METHODS.YES_REMOVE_PAYMENT_METHOD, "data-type": DATA_TYPE.MAKE_A_PAYMENT, dataCy: "remove-payment-method-confirm-button", isDesktop: isDesktop, onClick: () => handleConfirmDeletePaymentMethod(paymentMethod) }, { children: t('button.yesRemovePaymentMethod') })), _jsx(CloseIconWrapper, { children: _jsx(Button, Object.assign({ buttonType: "text", "data-analytics": DATA_ANALYTICS.CLICK_TRACKING_EVENT, "data-reason": DATA_REASON.MANAGE_PAYMENT_METHODS.X_BUTTON_BODY, "data-testid": "close-delete-prompt-button", "data-type": DATA_TYPE.MAKE_A_PAYMENT, dataCy: "remove-payment-method-close-button", onClick: onClose }, { children: _jsx(CloseIcon, { "aria-hidden": true, icon: FAL_TIMES }) })) })] })] })] })));
};
export default PaymentMethodRemovePrompt;
